export default [
    'aol.com',
    'aol.jp',
    'asahi-net.co.jp',
    'asahi-net.or.jp',
    'asahinet.jp',
    'att.ne.jp',
    'au.com',
    'bb-west.ne.jp',
    'bbiq.jp',
    'biglobe.ne.jp',
    'canvas.ne.jp',
    'commufa.jp',
    'disney.ne.jp',
    'docomo.ne.jp',
    'emnet.ne.jp',
    'emobile-s.ne.jp',
    'eonet.ne.jp',
    'ezweb.ne.jp',
    'gmail.com',
    'gol.com',
    'googlemail.com',
    'hinet.net',
    'hotmail.com',
    'hotmail.com.tw',
    'hotmail.co.jp',
    'hotmail.tw',
    'i.softbank.jp',
    'icloud.com',
    'infoseek.jp',
    'infoweb.ne.jp',
    'itscom.net',
    'jcom.home.ne.jp',
    'kdt.ne.jp',
    'kimo.com',
    'live.com',
    'live.jp',
    'livemail.tw',
    'mac.com',
    'me.com',
    'mineo.jp',
    'mopera.net',
    'msn.com',
    'my.email.ne.jp',
    'nifty.com',
    'nifty.ne.jp',
    'nk.oct-net.jp',
    'ocn.ne.jp',
    'oct-net.ne.jp',
    'odn.ad.jp',
    'odn.ne.jp',
    'outlook.com',
    'outlook.jp',
    'pdx.ne.jp',
    'plala.or.jp',
    'qq.com',
    'rakuten.com',
    'rakuten.co.jp',
    'rakuten.jp',
    'rocketmail.com',
    'sky.tu-ka.ne.jp',
    'so-net.ne.jp',
    'softbank.ne.jp',
    'spinnet.jp',
    'srg-m.com',
    'suisui-w.ne.jp',
    'tmtv.ne.jp',
    'us.oct-net.jp',
    'wcm.ne.jp',
    'willcom.com',
    'y-mobile.ne.jp',
    'yahoo.com',
    'yahoo.com.cn',
    'yahoo.com.hk',
    'yahoo.com.sg',
    'yahoo.com.tw',
    'yahoo.co.jp',
    'yahoo.ne.jp',
    'ybb.ne.jp',
    'ymail.com',
    'ymobile.ne.jp',
    'yopmail.com',
    '126.com',
    '163.com',
    '188.com',
    '246.com',
    '*.246.ne.jp',
    '*.att.ne.jp',
    '*.au.com',
    '*.bb-west.ne.jp',
    '*.bbiq.jp',
    '*.biglobe.ne.jp',
    '*.canvas.ne.jp',
    '*.catv.ne.jp',
    '*.commufa.jp',
    '*.eonet.ne.jp',
    '*.ezweb.ne.jp',
    '*.hinet.net',
    '*.ido.ne.jp',
    '*.infoweb.ne.jp',
    '*.itscom.net',
    '*.nifty.com',
    '*.nifty.ne.jp',
    '*.ocn.ne.jp',
    '*.odn.ad.jp',
    '*.odn.ne.jp',
    '*.pdx.ne.jp',
    '*.plala.or.jp',
    '*.rakuten.com',
    '*.rakuten.co.jp',
    '*.sky.dtg.ne.jp',
    '*.sky.tkc.ne.jp',
    '*.sky.tkk.ne.jp',
    '*.sky.tuka.ne.jp',
    '*.so-net.ne.jp',
    '*.spinnet.jp',
    '*.srg-m.com',
    '*.suisui-w.ne.jp',
    '*.vodafone.ne.jp',
    '*.zaq.ne.jp',
];
